import { FIELD_TYPES } from '../../../components/ui/Form/builder/formFieldTypes';

export function getUserFormSections({ showOrganisationField = true } = {}) {
  const fields = [
        {
          name: 'first_name',
          label: 'First Name',
          type: FIELD_TYPES.TEXT,
          required: true,
          placeholder: 'Enter First Name',
          inputProps: { maxLength: 25 },
          grid: { xs: 12, md: 6 },
        },
        {
          name: 'last_name',
          label: 'Last Name',
          type: FIELD_TYPES.TEXT,
          required: true,
          placeholder: 'Enter Last Name',
          inputProps: { maxLength: 15 },
          grid: { xs: 12, md: 6 },
        },
        {
          name: 'username',
          label: 'Username',
          type: FIELD_TYPES.TEXT,
          required: true,
          placeholder: 'Enter Username',
          inputProps: { maxLength: 35 },
          grid: { xs: 12, md: 6 },
        },
        {
          name: 'email',
          label: 'Email',
          type: FIELD_TYPES.TEXT,
          required: true,
          placeholder: 'Enter Email',
          inputProps: { maxLength: 50 },
          grid: { xs: 12, md: 6 },
        },
        {
          name: 'mobile',
          label: 'Mobile Number',
          type: FIELD_TYPES.TEXT,
          required: true,
          placeholder: 'Enter Mobile Number',
          inputProps: {
            maxLength: 12,
            inputMode: 'numeric',
            pattern: '[0-9]*',
          },
          grid: { xs: 12, md: 6 },
        },
  ];

  if (showOrganisationField) {
    fields.push({
      name: 'organisation',
      label: 'Select Organisation',
      type: FIELD_TYPES.CUSTOM,
      required: true,
      grid: { xs: 12, md: 6 },
    });
  }

  fields.push({
    name: 'profile',
    label: 'Assign Profile',
    type: FIELD_TYPES.CUSTOM,
    required: true,
    grid: { xs: 12, md: showOrganisationField ? 6 : 12 },
  });

  return [
    {
      id: 'identity',
      title: 'User details',
      description: 'Basic account information for the user.',
      variant: 'card',
      fields,
    },
  ];
}

export function getUserFormFieldOrder(sections = getUserFormSections()) {
  return sections.flatMap((section) => section.fields.map((field) => field.name));
}
